<script lang="ts">
  import TopNavNext from '@/platform-redesign-components/TopNavNext.svelte';
  import TopNavRecap from '@/platform-redesign-components/TopNavRecap.svelte';
  import {isMobile, project, step} from '@/store';
  import {STEP} from '@/types/common';
  import {onMount} from 'svelte';
  import Swal from 'sweetalert2';
  import Brandkit from '../../pages/user-settings/BrandKit.svelte';
  import NewTopNav from '@/platform-redesign-components/NewTopNav.svelte';
  import {events} from '@/utils/custom-event-names';
  import {tooltip} from '@/actions/tippy-action';

  export let openNavbar = false;
  let showAccountDropDown = false;

  const avatarURL = (window as any).avatarURL || '';
  const uData = window.uData;

  function listenToCloseDropDown(event: Event) {
    showAccountDropDown = false;
  }

  function reset() {
    project.reset();
    step.set(STEP.CHOOSE_VIDEO);
  }
  function signout() {
    // get wordpress document and get the signout link from there, the signout link requires a nonce so it cannot be static
    fetch('/wp-login.php?action=logout')
      .then(res => res.text())
      .then(data => {
        const dom = new DOMParser().parseFromString(data, 'text/html');
        const link = dom.querySelector('a')?.href || '';

        if (link === '') {
          Swal.fire({
            position: 'bottom-end',
            icon: 'error',
            title: 'Failed to sign out',
            showConfirmButton: false,
            timer: 1500,
            toast: true
          });
          return;
        }

        const a = document.createElement('a');
        a.href = link;
        a.click();
      });
  }

  const win = window as any;
  const currentUser: {email: string; username: string} = win.currentUser;

  $: (showAccountDropDown && setTimeout(() => window.addEventListener('click', listenToCloseDropDown))) ||
    window.removeEventListener('click', listenToCloseDropDown);
</script>

<div
  class="flex w-full gap-4 border-b border-b-zinc-200 bg-white px-4 py-3 shadow dark:border-b-zinc-600 dark:bg-zinc-700 dark:shadow-none {$step ===
  STEP.PREVIEW
    ? 'lg:h-20'
    : 'h-20'}"
>
  <div class="h-full">
    <div class="flex h-full items-center">
      {#if !$isMobile}
        <button
          on:click={() => {
            window.dispatchEvent(new Event(events.openSideNav));
          }}
          class="my-1 flex aspect-square items-center justify-center rounded-md p-1 lg:hover:bg-zinc-300"
          use:tooltip={'Open sidebar'}
        >
          <i class="fa-solid fa-bars text-2xl text-zinc-600"></i>
        </button>
        <!-- <hr class="border-t border-gray-200 dark:border-gray-500" /> -->
        <div class="mx-4 inline-block h-[68px] w-[1px] shrink-0 bg-gray-300"></div>
      {/if}
      <img
        on:click={reset}
        use:tooltip={'Back to home'}
        on:keypress={reset}
        class="h-[50px] w-[50px] cursor-pointer {$isMobile || (openNavbar && $step) === STEP.CHOOSE_VIDEO
          ? 'hidden'
          : ''}"
        src="https://storage.googleapis.com/sermonshots-homepage/v2/images/minilogo.png"
        alt="logo-min"
      />
      <div
        class="mr-auto h-full min-w-[256px] {$isMobile || !openNavbar || $step !== STEP.CHOOSE_VIDEO ? 'hidden' : ''}"
      >
        <img
          class="block h-full p-[0.4rem] dark:hidden"
          src="https://storage.googleapis.com/sermonshots-homepage/v2/images/logo-shadow.png"
          alt="logo-shadow"
        />
        <img
          class="hidden h-full p-[0.4rem] dark:block"
          src="https://storage.googleapis.com/sermonshots-homepage/v2/images/logo-shadow-dark.png"
          alt="logo-shadow"
        />
      </div>
    </div>
  </div>
  <div class="flex w-full items-center justify-between">
    <div
      class="{$step !== STEP.CHOOSE_VIDEO && $step !== STEP.ADMIN && $step !== STEP.BRANDKIT
        ? ''
        : 'hidden'} h-full w-full"
    >
      {#if $step === STEP.HIGHLIGHT_SUBTITLE || $step === STEP.SELECT_INTRO || $step === STEP.RECAP_PREVIEW}
        <TopNavRecap />
      {:else}
        <NewTopNav />
      {/if}
    </div>
    <div
      class="{$step === STEP.CHOOSE_VIDEO || $step === STEP.ADMIN
        ? ''
        : 'hidden'} flex w-full items-center justify-between"
    >
      <div class="flex items-center gap-2">
        <button
          on:click={() => (openNavbar = !openNavbar)}
          class="my-1 flex aspect-square items-center justify-center rounded-md p-1 lg:hover:bg-zinc-300"
        >
          <i class="fa-solid fa-bars text-xl text-zinc-600"></i>
        </button>
        <h1 class="text-3xl font-bold text-gray-800 dark:text-zinc-100">Sermons</h1>
      </div>
      <div class="relative flex gap-1">
        <div
          on:click={() => (showAccountDropDown = !showAccountDropDown)}
          on:keypress={() => (showAccountDropDown = !showAccountDropDown)}
          class="relative mx-2 my-1 flex aspect-square h-10 cursor-pointer items-center"
        >
          <img class="h-full rounded-full border-2 border-zinc-700 dark:border-zinc-100" src={avatarURL} alt="avatar" />
          <div class="absolute bottom-0.5 right-0.5 h-3 w-3 rounded-full bg-emerald-500 text-transparent"></div>
        </div>
        {#if !$isMobile}
          <div class="grid">
            <h1 class="text-lg font-medium capitalize">
              {uData ? `${uData.user_firstname?.toLowerCase() + ' ' + uData.user_lastname?.toLowerCase()}` : 'Username'}
            </h1>
            <h1 class="text-sm text-zinc-700">{uData ? uData.user_email : 'user@email.com'}</h1>
          </div>
          <div class="flex items-center gap-2 pl-4 pr-3 text-zinc-900 dark:text-zinc-100">
            <button
              on:click={() => (showAccountDropDown = !showAccountDropDown)}
              class="flex items-center"
              title="account dropdown"
            >
              <i class="fa-solid fa-chevron-down"></i>
            </button>
          </div>
        {/if}
        <!-- Account Dropdown -->
        <div class="absolute right-0 top-0 z-10 mt-2 pt-16 {!showAccountDropDown ? 'hidden' : ''}">
          <div
            class="grid w-full min-w-[256px] rounded-md border border-zinc-200 bg-white shadow dark:border-zinc-600 dark:bg-zinc-700"
          >
            <a class="px-4 py-2 transition-all hover:bg-zinc-100" href="/account" title="account" target="_blank"
              >Account</a
            >
            <button
              on:click={() => signout()}
              class="px-4 py-2 text-start transition-all hover:bg-zinc-100"
              title="sign out">Sign Out</button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
